import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTrophy = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.375 7H22.75V5.25a.875.875 0 0 0-.875-.875H6.125a.875.875 0 0 0-.875.875V7H2.625a1.75 1.75 0 0 0-1.75 1.75v1.75a4.375 4.375 0 0 0 4.375 4.375h.4a8.765 8.765 0 0 0 7.475 6.082v2.668H10.5a.875.875 0 0 0 0 1.75h7a.875.875 0 1 0 0-1.75h-2.625v-2.67c3.493-.354 6.392-2.805 7.446-6.08h.429a4.375 4.375 0 0 0 4.375-4.375V8.75A1.75 1.75 0 0 0 25.375 7ZM5.25 13.125A2.625 2.625 0 0 1 2.625 10.5V8.75H5.25v3.5c0 .292.014.583.043.875H5.25ZM21 12.152c0 3.885-3.172 7.07-7 7.098a7 7 0 0 1-7-7V6.125h14v6.027Zm4.375-1.652a2.625 2.625 0 0 1-2.625 2.625h-.055c.036-.323.055-.648.055-.973V8.75h2.625v1.75Z" />
  </svg>
);
export default SvgTrophy;
